import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  removeSaveProgress,
  setSaveProgress,
} from "Actions/SaveProgressAction";
import pointingHandIcon from "Assets/Svg/hand-pointing-right.svg";
import classNames from "classnames";
import DrawerHeader from "Component/Headers/drawerHeader";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../Actions/AxiosInstance";
import { refreshProfileInfo } from "../../../../Actions/commonAction";
import newTab from "../../../../Assets/Icons/new-tab-w.svg";
import CheckImg from "../../../../Assets/Images/aaa.png";
import crossIcon from "../../../../Assets/newicons/action/cancel/glyph/cancel-glyph-red-16px .svg";
import If from "../../../../Component/Common/If";
import { DatePickerComponent } from "../../../../Component/Custom";
import createstore from "../../../../store";
import {
  convertDateForBackend,
  getEJ2CalenderDateFormat,
  getFormattedDate,
  getFormattedImageLink,
} from "../../../../Utils/index";
import moment from "moment";

const styles = (theme) => ({
  button: {
    margin: theme.spacing.unit,
  },
});

class WorkDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideButton: false,
      viewpage: true,
      dataReceived: false,
      DrawerOpen: false,
      isnextpage: false,
      mythought: [],
      verifieddata: [],
      olddoj: null,
      newdoj: null,
    };

    this.onCancel = this.onCancel.bind(this);
    this.onCancel1 = this.onCancel1.bind(this);
    this.SelectDate = this.SelectDate.bind(this);
    this.UpdatePersonalDetails = this.UpdatePersonalDetails.bind(this);
    this.editDoj = this.editDoj.bind(this);
    this.onVerify = this.onVerify.bind(this);
    this.onSavechanges = this.onSavechanges.bind(this);
    this.onChecklistassignment = this.onChecklistassignment.bind(this);
  }

  componentWillMount() {
    const { SubscriptionInfo } = createstore.getState();
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;
    let { employeeid } = SubscriptionInfo.SubscriptionData;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
    }
    const { colleagueid } = this.props.match.params;
    const masterprofileid = get(
      AuthenticationAction,
      "login.masterprofileid",
      9,
    );
    const { permissions } = this.props;
    let hideButton;
    permissions.editable
      ? colleagueid && colleagueid != employeeid
        ? masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false)
        : (hideButton = false)
      : masterprofileid != 9
      ? (hideButton = true)
      : (hideButton = false);
    hideButton = this.props.history.location.pathname.includes(
      "completeprofile",
    )
      ? this.props.history.location.pathname.includes("completeprofile")
      : hideButton;
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        masterprofileid,
      },
      () => {
        this.GetProfileBasicInfo();
        this.GetProfileBasicInfo1();
      },
    );
  }

  onChecklistassignment(value) {
    const { mythought } = this.state;
    if (value == 1) {
      const employeeLink = `${window.location.origin}/app/resolve/checklist`;
      window.open(employeeLink, "_blank");
    } else {
      const employeeLink = `${window.location.origin}/app/pay/payroll/employee/payslip/${mythought.employeeid}`;
      window.open(employeeLink, "_blank");
    }
  }

  onSavechanges() {
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    const data = {
      employeeid: this.state.colleagueid || this.state.employeeid,
      newdoj: convertDateForBackend(this.state.newdoj),
      previousdoj: convertDateForBackend(this.state.olddoj),
    };
    if (!issaveinprogress) {
      const URL = "employee/updateemployeedoj";
      this.props.setSaveProgress(true);
      instance
        .patch(URL, data)
        .then((result) => {
          this.setState(
            {
              DrawerOpen: false,
              isnextpage: false,
            },
            () =>
              this.props.enqueueSnackbar(
                "date of joining changed successfully",
                {
                  variant: "success",
                },
              ),
          );
          this.GetProfileBasicInfo();
          this.props.removeSaveProgress();

          // let data = {};
          // result.data.result.length > 0
          //   ? (data = result.data.result[0])
          //   : (data = {});
          // this.setState({
          // let data = {};
          // result.data.result.length > 0
          // let data = {};
          // result.data.result.length > 0
          //   data,
          //   dataReceived: true,
          // });
        })
        .catch((error) => {
          this.props.removeSaveProgress();
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  GetProfileBasicInfo() {
    const data = {
      employeeid: this.state.colleagueid || this.state.employeeid,
    };
    const URL = "employee/empworkdetail";
    instance
      .post(URL, data)
      .then((result) => {
        let data = {};
        result.data.result.length > 0
          ? (data = result.data.result[0])
          : (data = {});
        this.setState({
          data,
          olddoj: data.doj,
          newdoj: data.doj,
          dataReceived: true,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  GetProfileBasicInfo1() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        // let ProfileBasicInfo = [];
        // result.data.result.length > 0
        //   ? (ProfileBasicInfo = result.data.result[0])
        //   : (ProfileBasicInfo = []);
        // const { mythought } = ProfileBasicInfo;
        this.setState({ mythought: result.data.result[0] });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getEditMode() {
    this.setState({
      viewpage: false,
    });
  }

  editDoj() {
    this.setState({
      DrawerOpen: true,
    });
  }

  onCancel() {
    const { data } = this.state;
    data.doj = "";
    this.setState({
      viewpage: true,
      data,
    });
  }

  onCancel1() {
    const { data } = this.state;
    // data.doj = "";
    this.setState({
      viewpage: true,
      isnextpage: false,
      DrawerOpen: false,
      // data,
      newdoj: data.doj,
    });
  }

  UpdatePersonalDetails() {
    if (this.state.data && !this.state.data.doj) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      const data = {
        doj: convertDateForBackend(this.state.data.doj),
        employeeid: this.state.colleagueid || this.state.employeeid,
      };
      instance
        .post("employee/changedoj", data)
        .then((result) => {
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.setState({
            viewpage: true,
          });
          this.GetProfileBasicInfo();
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  onVerify() {
    const { mythought, data, newdoj } = this.state;
    const employeeid = mythought.employeeid;
    const newdoj1 = convertDateForBackend(newdoj);
    instance
      .get(`employee/verifychangedojchecklist/${employeeid}/${newdoj1}`)
      .then((result) => {
        this.setState({
          verifieddata: result.data.result[0],
          isDetails: false,
          isnextpage: true,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({ CommonError });
      });
  }

  SelectDate(name, e) {
    const { data } = this.state;
    data[name] = e.value;
    // [key ]
    this.setState({
      data,
      [name]: e.value,
    });
  }

  showComp = (value) => <div className="address-data">{value || "-"}</div>;

  render() {
    const { dataReceived, viewpage, data } = this.state;
    let istentative = true;
    if (data && data.tentativeexitdate && data.tentativeexitdate != null) {
      istentative =
        moment(new Date()).format("YYYY-MM-DD") >=
        moment(data.tentativeexitdate).format("YYYY-MM-DD")
          ? false
          : true;
    }

    const dojmax = moment(new Date()).add(15, "days").format("YYYY-MM-DD");

    const getdisplaybutton = () => {
      if (this.props.history.location.pathname.includes("completeprofile")) {
        return true;
      } else if (
        !this.props.history.location.pathname.includes("completeprofile")
      ) {
        if (this.state.masterprofileid == 9) {
          return true;
        } else {
          return false;
        }
      }
    };

    return (
      <div>
        <If condition={dataReceived}>
          <div style={{ position: "relative" }}>
            {data && data.stageid !== 6 && data.stageid !== 7 && (
              <svg
                className={
                  getdisplaybutton() ? "biodata-edit-btn" : "hide-button"
                }
                // onClick={this.getEditMode.bind(this)}
                // let data = {};
                // result.data.result.length > 0
                onClick={() => this.editDoj()}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style={{ zIndex: 10 }}
              >
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM5.92 19H5v-.92l9.06-9.06.92.92L5.92 19zM20.71 5.63l-2.34-2.34c-.2-.2-.45-.29-.71-.29s-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41z" />
              </svg>
            )}
            <div className="emp-from-wrapper">
              <div className="form-height">
                <div id="div">
                  <form
                    className="custom-form-box profile-about profile-imp-dates"
                    autoComplete="off"
                  >
                    <div className="inner-wrapper opaque" tabIndex="0">
                      <div className="margin-bottom-20 dependent-datepicker width100">
                        <p className="input-form-label">
                          <FormattedMessage
                            id="_LbDateofJoining"
                            defaultMessage="Date of Joining"
                          />
                        </p>
                        {viewpage ? (
                          this.showComp(
                            data && data.doj && getFormattedDate(data.doj),
                          )
                        ) : (
                          <div>
                            <DatePickerComponent
                              className="datepicker"
                              placeholder="Date of joining"
                              format={getEJ2CalenderDateFormat()}
                              width={"100%"}
                              id="dob"
                              start="Decade"
                              allowEdit={true}
                              // onClick={() => this.dateObj3.show()}
                              // // ref={(date)) => (this.dateObj3 = date)}
                              change={(e) => this.SelectDate("doj", e)}
                              value={get(this.state, "data.doj", "")}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="1">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <span className="emp-special-head">
                              <FormattedMessage
                                id="_LbEmploymentStage"
                                defaultMessage="Employment Stage"
                              />
                            </span>
                          </p>
                          {this.showComp(get(data, "stage", ""))}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="2">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="__LbEmploymentType"
                              defaultMessage="Employment Type"
                            />
                          </p>
                          {this.showComp(
                            data && data.employmenttype && data.employmenttype,
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="3">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="LbEmploymentGrade"
                              defaultMessage="Employment Grade"
                            />
                          </p>
                          {this.showComp(data && data.grade && data.grade)}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="4">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="_LbSelfService"
                              defaultMessage="Self Service"
                            />{" "}
                          </p>
                          {this.showComp(
                            data && data.selfservice && data.selfservice,
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="5">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="__LbProbationEndDate"
                              defaultMessage="Probation End Date"
                            />{" "}
                          </p>
                          {this.showComp(
                            data &&
                              data.dateofprobation &&
                              getFormattedDate(data.dateofprobation),
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="6">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="__LbDateofConfirmation"
                              defaultMessage="Date of Confirmation"
                            />{" "}
                          </p>
                          {this.showComp(
                            data &&
                              data.dateofconfirmation &&
                              getFormattedDate(data.dateofconfirmation),
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="inner-wrapper opaque" tabIndex="9">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="___LbLastWorkingDate"
                              defaultMessage="Notice period start date"
                            />{" "}
                          </p>
                          {this.showComp(
                            data &&
                              data.expectedresignationdate &&
                              getFormattedDate(data.expectedresignationdate),
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="inner-wrapper opaque" tabIndex="8">
                      {viewpage ? (
                        <div className="form-group">
                          <p className="input-form-label">
                            <FormattedMessage
                              id="____LbResignedOn"
                              defaultMessage="Exit date"
                            />{" "}
                          </p>
                          {this.showComp(
                            data && data.resigneddate
                              ? getFormattedDate(data.resigneddate)
                              : data &&
                                  data.tentativeexitdate &&
                                  `${getFormattedDate(
                                    data.tentativeexitdate,
                                  )} ${istentative ? "(Tentative)" : ""}`,
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    {!viewpage && (
                      <div className="upform-footer">
                        <Button
                          className="form-btn form-control margin-top-24"
                          variant="contained"
                          color="primary"
                          size="large"
                          onClick={this.UpdatePersonalDetails}
                        >
                          <FormattedMessage id="BtSave" defaultMessage="Save" />
                        </Button>
                        <span tabIndex="6" className="margin-left-16 ">
                          <Button
                            size="large"
                            className="margin-top-24"
                            onClick={this.onCancel}
                          >
                            <span>
                              <FormattedMessage
                                id="BtCancel"
                                defaultMessage="Cancel"
                              />
                            </span>
                          </Button>
                        </span>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
            <Drawer
              anchor="right"
              open={this.state.DrawerOpen}
              onClose={() => this.onCancel1()}
              style={{ padding: 40 }}
              classes={{
                paper: classNames(
                  // classes.drawerPaper,
                  "planner-drawer padding30 padding-right-4",
                ),
              }}
            >
              <div
                className="thin-scroll"
                style={{ height: "96vh", overflowY: "auto", paddingRight: 15 }}
              >
                <DrawerHeader
                  header={"Change Date of Joining"}
                  isbackarrow={false}
                  closeDrawer={() => this.onCancel1()}
                />
                {!this.state.isnextpage ? (
                  <>
                    <p className="normal-dark margin-bottom-8 display-flex">
                      <img
                        className="margin-right-16"
                        src={pointingHandIcon}
                      ></img>{" "}
                      Employee name
                    </p>
                    <div className="width60 margin-bottom-16 display-flex margin-left-32">
                      <img
                        className="profile-picture"
                        src={getFormattedImageLink(
                          this.state.mythought.imagepath,
                        )}
                        height="50"
                        width="50"
                      />
                      <p style={{ margin: 8 }}>
                        {this.state.mythought.fullname}
                      </p>
                    </div>
                    <p className="normal-dark margin-bottom-8 display-flex">
                      <img
                        className="margin-right-16"
                        src={pointingHandIcon}
                      ></img>{" "}
                      Enter new date of Joining
                    </p>
                    <div className="margin-left-32">
                      <DatePickerComponent
                        className="datepicker"
                        placeholder="Date of joining"
                        format={getEJ2CalenderDateFormat()}
                        width={"50%"}
                        id="dob"
                        start="Decade"
                        allowEdit={true}
                        // onClick={() => this.dateObj3.show()}
                        // // ref={(date)) => (this.dateObj3 = date)}
                        change={(e) => this.SelectDate("newdoj", e)}
                        value={get(this.state, "newdoj", "")}
                        max={dojmax}
                      />
                    </div>
                    <div
                      className="helping-hand-wrapper margin-top-16"
                      style={{
                        paddingLeft: 16,
                        width: "calc(100% - 34px)",
                        marginBottom: 32,
                      }}
                    >
                      <p className="helping-hand-text text-center margin-bottom-16">
                        Helping Hand 👋
                      </p>
                      <p className="small-dark-secondary  margin-bottom-8">
                        In the next step you be asked to take actions on:
                      </p>
                      <ul
                        className="padding-left-0"
                        style={{ listStyleType: "none" }}
                      >
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Employee’s salary
                          </span>
                        </li>
                        {/* <li className="extra-small-dark-secondary t-bold margin-bottom-16"> */}
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Generated payslips
                          </span>
                        </li>
                      </ul>
                      <p className="small-dark-secondary  margin-bottom-8">
                        The sumHR system will perform these actions autmatically
                        (if applicable):
                      </p>
                      <ul
                        className="padding-left-0"
                        style={{ listStyleType: "none" }}
                      >
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Checklist assignment
                          </span>
                        </li>
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Change of probation end
                          </span>
                        </li>
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Sync or deletion of previous attendance logs
                          </span>
                        </li>
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Optional holidays of the employee will reset
                          </span>
                        </li>
                      </ul>
                    </div>

                    <Grid md="12">
                      <div className="floatleft" style={{}}>
                        <Button
                          className="btn btn-trans margin-right-16"
                          variant="contained"
                          onClick={() => this.onCancel1()}
                        >
                          Cancel
                        </Button>
                      </div>
                      <div className="floatright" style={{}}>
                        <Button
                          className={
                            this.state.olddoj ==
                            (this.state.data && this.state.newdoj)
                              ? "btn btn-primary-md-grey"
                              : "btn btn-primary-md-blue"
                          }
                          variant="contained"
                          disabled={
                            this.state.olddoj ==
                            (this.state.data && this.state.newdoj)
                          }
                          onClick={() => this.onVerify()}
                          // onClick={() => this.setState({
                          //  isnextpage: true,
                          // })}
                        >
                          Next
                        </Button>
                      </div>
                      <div className="clearfloat"></div>
                    </Grid>
                  </>
                ) : (
                  <>
                    <div
                      className="helping-hand-wrapper"
                      style={{
                        paddingLeft: 16,
                        width: "calc(100% - 34px)",
                        marginBottom: 32,
                      }}
                    >
                      <p className="helping-hand-text text-center margin-bottom-16">
                        Helping Hand 👋
                      </p>
                      <ul
                        className="padding-left-0"
                        style={{ listStyleType: "none" }}
                      >
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Step 1: Navigate to the page (links will open in new
                            tab).
                          </span>
                        </li>
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Step 2: Make the necessary changes and save them.
                            Repeat for all actions.
                          </span>
                        </li>
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Step 3: Repeat for all actions
                          </span>
                        </li>
                        <li className="extra-small-dark-secondary t-bold margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Step 4: Click ‘Verify’ on this page. Check if all
                            the actions are marked as done.
                          </span>
                        </li>
                        <li className="small-dark-secondary margin-bottom-8">
                          <span
                            className="dot"
                            style={{
                              backgroundColor: "#6648ad",
                              width: 6,
                              height: 6,
                              borderRadius: 4,
                              marginRight: 8,
                              display: "inline-block",
                            }}
                          ></span>
                          <span
                            className="extra-small-dark"
                            style={{ color: "#0D0D0D", fontWeight: 400 }}
                          >
                            Step 5: Save changes
                          </span>
                        </li>
                      </ul>
                    </div>
                    <p
                      style={{ marginTop: 16, marginBottom: 8 }}
                      className="small-dark"
                    >
                      Complete the following actions for{" "}
                      {this.state.mythought.fullname}:
                    </p>

                    <div
                      style={{
                        border: "1px solid #D2D2D2",
                        padding: 16,
                        borderRadius: 4,
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          borderBottom: "1px solid #D2D2D2",
                          marginBottom: 16,
                          paddingBottom: 16,
                        }}
                      >
                        <div className="display-flex">
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderRadius: 26,
                              padding: 10,
                              marginRight: 16,
                              height: 20,
                              width: 20,
                            }}
                          >
                            {this.state.verifieddata.salary ? (
                              <img src={CheckImg} alt="icon" height="20" />
                            ) : (
                              <img
                                // src={salaryIcon}
                                src={crossIcon}
                                alt="icon"
                                height="20"
                              />
                            )}
                          </div>
                          <div>
                            <p className="small-dark-secondary t-bold margin-bottom-8">
                              Delete salary structure and FBP
                            </p>
                            <p className="small-dark-secondary">
                              The salary structure and FBP need to be reassigned
                              after the date change.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div>
                        <div className="display-flex">
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderRadius: 26,
                              padding: 10,
                              marginRight: 16,
                              height: 20,
                              width: 20,
                            }}
                          >
                            {this.state.verifieddata.payslip ? (
                              <img src={CheckImg} alt="icon" height="20" />
                            ) : (
                              <img
                                // src={policyoutlined}
                                src={crossIcon}
                                alt="icon"
                                height="20"
                              />
                            )}
                          </div>
                          <div style={{ width: "90%" }}>
                            <div
                              className="display-flex"
                              style={{
                                justifyContent: "space-between",
                              }}
                            >
                              <p className="small-dark-secondary t-bold margin-bottom-8">
                                Delete payslips
                              </p>
                              {!this.state.verifieddata.payslip && (
                                <div
                                  onClick={() => this.onChecklistassignment(2)}
                                  style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <span className="small-blue t-bold margin-right-8">
                                    Go to page
                                  </span>
                                  <img
                                    src={newTab}
                                    style={{ cursor: "pointer" }}
                                  ></img>
                                </div>
                              )}
                            </div>
                            <p className="small-dark-secondary">
                              All payslips generated before the new DOJ need to
                              be deleted.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <p
                      style={{ marginTop: 16, marginBottom: 8 }}
                      className="small-dark"
                    >
                      These actions will be performed automatically:
                    </p>

                    <div
                      style={{
                        border: "1px solid #D2D2D2",
                        padding: 16,
                        borderRadius: 4,
                      }}
                    >
                      <div
                        style={{
                          borderBottom: "1px solid #D2D2D2",
                          marginBottom: 16,
                          paddingBottom: 16,
                        }}
                      >
                        <div className="display-flex">
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderRadius: 26,
                              padding: 10,
                              marginRight: 16,
                              height: 20,
                              width: 20,
                            }}
                          >
                            {this.state.verifieddata.checklist ? (
                              <img src={CheckImg} alt="icon" height="20" />
                            ) : (
                              <img
                                // src={checklistoutlined}
                                src={crossIcon}
                                alt="icon"
                                height="20"
                              />
                            )}
                          </div>
                          <div>
                            <p
                              className="small-dark-secondary t-bold"
                              style={{ marginBottom: 8 }}
                            >
                              Remove from all checklists
                            </p>
                            <p className="small-dark-secondary" style={{}}>
                              Employee will get added to auto-checklists by the
                              system.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          borderBottom: "1px solid #D2D2D2",
                          marginBottom: 16,
                          paddingBottom: 16,
                        }}
                      >
                        <div className="display-flex">
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderRadius: 26,
                              padding: 10,
                              marginRight: 16,
                              height: 20,
                              width: 20,
                            }}
                          >
                            {this.state.verifieddata.attendance != 1 &&
                            this.state.verifieddata.attendance != 2 ? (
                              <img src={CheckImg} alt="icon" height="20" />
                            ) : (
                              <img
                                // src={attendanceIcon}
                                src={crossIcon}
                                alt="icon"
                                height="20"
                              />
                            )}
                          </div>
                          <div>
                            <p
                              style={{ marginBottom: 8 }}
                              className="small-dark-secondary t-bold "
                            >
                              {this.state.verifieddata.attendance == 1
                                ? "Sync attendance logs"
                                : this.state.verifieddata.attendance == 2
                                ? "Delete attendance logs"
                                : "There will be no changes in attandance logs"}
                            </p>
                            {/* <p className="margin-left-40" >Go to page</p>
                        <img
                          src={newTab}
                          // onClick={
                          // }
                          style={{ cursor: "pointer" }}
                        ></img> */}

                            <p className="small-dark-secondary" style={{}}>
                              Missing logs will marked as absent and logs before
                              new DOJ will be deleted
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          borderBottom: "1px solid #D2D2D2",
                          marginBottom: 16,
                          paddingBottom: 16,
                        }}
                      >
                        <div className="display-flex">
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderRadius: 26,
                              padding: 10,
                              marginRight: 16,
                              height: 20,
                              width: 20,
                            }}
                          >
                            {this.state.verifieddata.leave > 0 ? (
                              <img src={CheckImg} alt="icon" height="20" />
                            ) : (
                              <img
                                // src={leavesIcon}
                                src={crossIcon}
                                alt="icon"
                                height="20"
                              />
                            )}
                          </div>
                          <div>
                            <p
                              style={{ marginBottom: 8 }}
                              className="small-dark-secondary t-bold "
                            >
                              Re-calculate leaves
                            </p>
                            {/* <p className="margin-left-40" >Go to page</p>
                        <img
                          src={newTab}
                          // onClick={
                          // }
                          style={{ cursor: "pointer" }}
                        ></img> */}

                            <p className="small-dark-secondary" style={{}}>
                              Leave balance will be re-allocated.
                            </p>
                          </div>
                        </div>
                      </div>

                      <div
                        style={{
                          borderBottom: "1px solid #D2D2D2",
                          marginBottom: 16,
                          paddingBottom: 16,
                        }}
                      >
                        <div className="display-flex">
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderRadius: 26,
                              padding: 10,
                              marginRight: 16,
                              height: 20,
                              width: 20,
                            }}
                          >
                            {this.state.verifieddata.probation ? (
                              <img src={CheckImg} alt="icon" height="20" />
                            ) : (
                              <img
                                // src={probationIcon}
                                src={crossIcon}
                                alt="icon"
                                height="20"
                              />
                            )}
                          </div>
                          <div>
                            <p
                              style={{ marginBottom: 8 }}
                              className="small-dark-secondary t-bold "
                            >
                              End of probation will be updated
                            </p>
                            {/* <p className="margin-left-40" >Go to page</p>
                        <img
                          src={newTab}
                          // onClick={
                          // }
                          style={{ cursor: "pointer" }}
                        ></img> */}

                            <p className="small-dark-secondary" style={{}}>
                              The employment status will reflect based on
                              probation fulfillment.
                            </p>
                          </div>{" "}
                        </div>
                      </div>

                      <div
                        style={{
                          marginBottom: 16,
                          paddingBottom: 16,
                        }}
                      >
                        <div className="display-flex">
                          <div
                            style={{
                              background: "#f7f8f8",
                              borderRadius: 20,
                              padding: 10,
                              height: 20,
                              marginRight: 16,
                              width: 20,
                            }}
                          >
                            {this.state.verifieddata.optionalholiday ? (
                              <img src={CheckImg} alt="icon" height="20" />
                            ) : (
                              <img
                                // src={holidayoutlined}
                                src={crossIcon}
                                alt="icon"
                                height="20"
                              />
                            )}
                          </div>
                          <div>
                            <p
                              style={{ marginBottom: 8 }}
                              className="small-dark-secondary t-bold "
                            >
                              Reset optional holidays
                            </p>
                            {/* <p className="margin-left-40" >Go to page</p>
                        <img
                          src={newTab}
                          // onClick={
                          // }
                          style={{ cursor: "pointer" }}
                        ></img> */}

                            <p className="small-dark-secondary" style={{}}>
                              Employee will have to select their optional
                              holidays again.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Grid
                      md="12"
                      style={{
                        marginTop: 16,
                        marginBottom: 16,
                      }}
                    >
                      <div className="floatleft" style={{}}>
                        <Button
                          className="btn btn-trans margin-right-16"
                          variant="contained"
                          onClick={() =>
                            this.setState({
                              isnextpage: false,
                            })
                          }
                        >
                          Back
                        </Button>
                      </div>
                      <div className="floatright">
                        <Button
                          className={
                            !this.state.verifieddata.payslip ||
                            !this.state.verifieddata.salary
                              ? "btn btn-primary-md-grey"
                              : "btn btn-primary-md-blue"
                          }
                          variant="contained"
                          disabled={
                            !this.state.verifieddata.payslip ||
                            !this.state.verifieddata.salary ||
                            this.props.SaveInProgressReducer.issaveinprogress
                          }
                          onClick={() => this.onSavechanges()}
                        >
                          Save
                        </Button>
                      </div>
                      <div className="floatright" style={{ marginRight: 72 }}>
                        <Button
                          // className="btn btn-primary-md-blue"
                          className={
                            this.state.verifieddata.payslip &&
                            this.state.verifieddata.salary
                              ? "btn btn-primary-md-grey"
                              : "btn btn-primary-md-blue"
                          }
                          variant="contained"
                          onClick={() => this.onVerify()}
                          disabled={
                            this.state.verifieddata.payslip &&
                            this.state.verifieddata.salary
                          }
                        >
                          verify
                        </Button>
                      </div>

                      <div className="clearfloat"></div>
                    </Grid>
                  </>
                )}
              </div>
            </Drawer>
          </div>
        </If>
      </div>
    );
  }
}

WorkDetail.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setSaveProgress,
      removeSaveProgress,
      refreshProfileInfo: (data) => refreshProfileInfo(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(WorkDetail)));
